const addOrdinalSuffix = (day) => {
    if (day === undefined)
        return '';
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const computation = (day > 3 && day < 21) || day % 10 > 3 ? 0 : day % 10;
    const suffix = day > 0 ? suffixes[computation] : '';
    return `${day}${suffix}`;
};
export default addOrdinalSuffix;
